import { render, staticRenderFns } from "./FileC2PAResult.vue?vue&type=template&id=dbfa4318&scoped=true"
import script from "./FileC2PAResult.vue?vue&type=script&lang=ts"
export * from "./FileC2PAResult.vue?vue&type=script&lang=ts"
import style0 from "./FileC2PAResult.vue?vue&type=style&index=0&id=dbfa4318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfa4318",
  null
  
)

export default component.exports